import * as Styled from "./FilledIconButton.styled"

export function FilledIconButton(props) {

    const {
        color,
        disabled,
        size,
        ...otherProps
    } = props

    return <Styled.FilledIconButton color={color} disabled={disabled} size={size} {...otherProps} />
}

FilledIconButton.defaultProps = {
    color: "primary",
    size: "medium",
}

FilledIconButton.propTypes = {
    ...Styled.FilledIconButton.propTypes,
}